export var epsilon = 1e-12;
export var pi = Math.PI;
export var halfPi = pi / 2;
export var tau = 2 * pi;



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/math.js
// module id = 275
// module chunks = 1